export default "__VITE_ASSET__DaggL8yx__"